import { render, staticRenderFns } from "./CvSendHistoryModal.vue?vue&type=template&id=265f6672&scoped=true"
import script from "./CvSendHistoryModal.vue?vue&type=script&lang=js"
export * from "./CvSendHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./CvSendHistoryModal.vue?vue&type=style&index=0&id=265f6672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265f6672",
  null
  
)

export default component.exports